import React from "react";
import { GoogleLogo, ShieldCheck } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-white">
      <div className="hidden md:block relative bg-slate-900 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1744937002634-af74010525dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxjYW5hZGlhbiUyMGNpdHklMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzc4NTQwOTg5fDA&ixlib=rb-4.1.0&q=85"
          alt="Canadian city skyline"
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A2F5B]/80 via-slate-900/80 to-slate-900/95" />
        <div className="relative h-full p-12 flex flex-col justify-between text-white">
          <div className="flex items-center gap-2">
            <img src="/canhiresolution-logo.png" alt="CanHireSolution.com" className="h-10 w-10 object-contain bg-white rounded-sm p-1" />
            <span className="text-xs uppercase tracking-[0.3em] font-semibold opacity-80">CanHireSolution · Canada</span>
          </div>
          <div>
            <h2 className="font-display text-4xl lg:text-5xl leading-none mb-4">
              Work that<br/>moves you<br/>forward.
            </h2>
            <p className="text-sm text-slate-200 max-w-sm">
              Join thousands of trusted Canadian pros and customers building real businesses together.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-8 inline-block" data-testid="back-home">
            ← Back to home
          </Link>
          <h1 className="font-display text-4xl mb-2">Sign in to CanHireSolution.com</h1>
          <p className="text-sm text-slate-600 mb-8">
            Secure sign-in with Google. We never share your data without consent.
          </p>

          <button
            onClick={handleGoogleLogin}
            className="w-full bg-white border-2 border-slate-900 text-slate-900 px-6 py-4 font-semibold flex items-center justify-center gap-3 hover:bg-slate-50 transition-colors active:scale-[0.98]"
            data-testid="google-signin-btn"
          >
            <GoogleLogo size={20} weight="bold" />
            Continue with Google
          </button>

          <div className="mt-6 flex items-start gap-2 text-xs text-slate-500">
            <ShieldCheck size={16} className="flex-shrink-0 mt-0.5" />
            <p>
              By continuing, you agree to our <Link to="/legal/terms" className="underline">Terms</Link> and acknowledge our <Link to="/legal/privacy" className="underline">Privacy Policy</Link>. Independent contractors review the <Link to="/legal/contractor" className="underline">Contractor Disclaimer</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
